import React, { useEffect, useState } from "react";
import CandidateSidebar from "./CandidateSidebar";
import "./Candidates.css";

const CandidatePageShell = ({ active, title, text, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("candidate-sidebar-visible", sidebarOpen);
    return () => document.body.classList.remove("candidate-sidebar-visible");
  }, [sidebarOpen]);

  useEffect(() => {
    document.body.classList.add("candidate-dashboard-active");
    return () => document.body.classList.remove("candidate-dashboard-active");
  }, []);

  return (
    <div className={`dashboard candidate-dashboard-page ${sidebarOpen ? "user-sidebar-active" : ""}`}>
      <button type="button" className="candidate-sidebar-toggle" onClick={() => setSidebarOpen(true)}>
        <span className="la la-bars"></span>
        Candidate Menu
      </button>

      <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)}></div>
      <CandidateSidebar active={active} onClose={() => setSidebarOpen(false)} />

      <section className="user-dashboard">
        <div className="dashboard-outer">
          <div className="upper-title-box">
            <h3>{title}</h3>
            <div className="text">{text}</div>
          </div>
          {children}
        </div>
      </section>

      <div className="copyright-text">
        <p>Copyright 2026 Epic-Jobs. All Right Reserved.</p>
      </div>
    </div>
  );
};

export default CandidatePageShell;
